import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import { PvBox, PvButton, PvInput } from 'styles/CustomComponents';

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;


const termSet = (term) => {
  return (term && term.length > 0 && !Array.isArray(term)) || (Array.isArray(term) && term.some((e) => termSet(e)));
};

const searchDisabled = (searchTerms) => {

  let givenTerms = Object.values(searchTerms).filter((e) => (termSet(e)));
  return givenTerms.length <= 0;
};

class DrivingApplicantsSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      executeSearch: true
    };
  }

  componentDidUpdate(prevProps) {
    // execute search automatically if flag set
    if (!!this.state.executeSearch) {
      this.setState({ executeSearch: false });
      this.props.searchFn(this.props.searchTerms);
    }
  }

  render() {
    const {
      searchFn,
      searchTerms,
      updateSearchTerms
    } = this.props;

    return (
      <PvBox my={3}>
        <Flex flexWrap='wrap'>
          <PvBox mb={[0, 0, 3]} w={[1, 1, 1]}>
            <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
              <Label mb={2}>
                <Translate value='search.course_number' />
              </Label>
              <PvInput
                type='search'
                value={this.props.searchTerms.courseNumber}
                disabled
              />
            </PvBox>
            <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
              <Label mb={2}>
                <Translate value='search.course_year' />
              </Label>
              <PvInput
                type='search'
                name='courseYear'
                value={this.props.searchTerms.courseYear}
                disabled
              />
            </PvBox>
            <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
              <Label mb={2}>
                <Translate value='search.course_unit' />
              </Label>
              <PvInput
                type='search'
                name='courseUnit'
                disabled
                value={this.props.searchTerms.courseUnit}
              />
            </PvBox>
            <PvBox display='inline-block' px={2} w={[1 / 2, 1 / 2, 1 / 8]}>
              <Label mb={2}>
                <Translate value='search.team' />
              </Label>
              <PvInput
                type='search'
                value={this.props.searchTerms.team}
                onChange={(e) => updateSearchTerms({team: e.target.value})} />
            </PvBox>
            <PvBox display='inline-block' px={2} w={[1 / 2, 1 / 2, 3 / 8]}>
              <Label mb={2}>
                <Translate value='search.applicant_name' />
              </Label>
              <PvInput
                type='search'
                name='applicantName'
                onChange={(e) => updateSearchTerms({applicantName: e.target.value})}
                value={this.props.searchTerms.applicantName}
              />
            </PvBox>
            <PvBox display='inline-block' px={2} w={[1 / 4, 2 / 8, 1 / 8]}>
              <PvSearchBtn px={3} width='100%'
                           disabled={searchDisabled(searchTerms)}
                           onClick={(e) => {
                             e.preventDefault();
                             searchFn(searchTerms);
                           }}>
                <Translate value='action.search' />
              </PvSearchBtn>
            </PvBox>
          </PvBox>
        </Flex>
      </PvBox>
    );
  }
}

DrivingApplicantsSearch.propTypes = {
  searchFn: PropTypes.func,
  searchTerms: PropTypes.object,
  updateSearchTerms: PropTypes.func,
  };

export default DrivingApplicantsSearch;


// WEBPACK FOOTER //
// ./src/containers/search/DrivingApplicantsSearch.jsx